import romanToInt from 'utils/romanToInt';
import { Issue, PollOverview } from './api.types';

export interface SortedIssue extends Issue {
  sortKey?: number;
}

export const getSortkeyForLocalIssue = (issueInfo: PollOverview) => {
  if (issueInfo?.scope === 'district') {
    return `a${issueInfo?.domain_name.de}`;
  }

  // get roman number from domain name (which comes either in format "Kreis III" or simply "III")
  const romanValue = issueInfo?.domain_name.de.split(' ').pop();
  const integerRomanValue = romanToInt(romanValue);
  // get correspondig letter from number (e.g. 1 -> A, 2 -> B, ...)
  const letterFromIntegerRomanValue = String.fromCharCode(integerRomanValue + 64);

  return `b${letterFromIntegerRomanValue}`;
};

// first alls districts (e.g. "Bezirk Aarau") alphabetically,
// then all Kreise (e.g. "Kreis III") by roman numbers
const sortLocalElections = (localElections: SortedIssue[]) => {
  const localElectionsWithSortKey = localElections.map((issue) => {
    return {
      ...issue,
      sortKey: getSortkeyForLocalIssue(issue.info),
    };
  });

  return localElectionsWithSortKey
    .sort((a, b) => {
      if (a.sortKey < b.sortKey) {
        return -1;
      }
      if (a.sortKey > b.sortKey) {
        return 1;
      }
      return 0;
    })
    .map((sortedIssue) => {
      const copyOfIssue = { ...sortedIssue };
      delete copyOfIssue.sortKey;
      return copyOfIssue;
    });
};

export default sortLocalElections;
